import {spacing, zIndex} from 'material-ui/styles';
import {fade} from 'material-ui/utils/colorManipulator';
import * as colors from 'material-ui/styles/colors';

export const textColor = colors.darkBlack;
const dodgerBlue = '#2486FB';
export const lynch = '#6B829D';
const silver = '#CCCCCC';
const gallery = '#EBEBEB';
const grey = '#808080';
const darkGrey = '#646464';
export const flamingo = '#EC6225';
export const blueBayoux = '#56697D';

/**
 * Object used to customize the muiTheme of material-ui.
 * It also contains app specific color variables.
 *
 * @deprecated - If you see this being used, try to replace it with colors from getMuiV4Theme
 */
export default {
  spacing,
  zIndex: zIndex,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    // material-ui color variables
    primary1Color: '#2979FF',
    primary2Color: '#2979FF',
    primary3Color: colors.lightBlack,
    delete1Color: '#F12C39',
    accent1Color: colors.pinkA200,
    accent2Color: colors.grey100,
    accent3Color: colors.grey500,
    textColor,
    alternateTextColor: colors.white,
    canvasColor: colors.white,
    borderColor: '#CCC',
    disabledColor: fade(colors.darkBlack, 0.3),
    secondaryTextColor: '#515151',
    dialogHeaderDescriptionTextColor: '#222222',
    buttonGrayColor: '#B7C0C8',
    cardInfoSectionBackgroundColor: '#F9FBFC',

    alto: '#D9D9D9',
    // app color variables
    actionButtonColor: '#C4C4C4',
    actionButtonLabelColor: '#7F7F7F',
    blueBayoux,
    bonjour: '#ede9ea',
    callActiveColor: '#FAFAFA',
    callBorderColor: '#DFDFDF',
    callGreyTextColor: '#898989',
    callPlayerMaskColor: '#BDC3C7',
    checkboxIconFillColor: '#8F8F8F',
    christine: '#E65F10',
    cinnabar: '#E54726',
    coachMeColor: '#00C853',
    darkBlueGrey: '#747F8F',
    darkGrey: '#646464',
    darkerGrey: darkGrey,
    deYork: '#7BBE8B',
    dodgerBlue,
    dustyGray: '#9A9A9A',
    flamingo,
    frenchPassAlt: '#C2D6FD',
    gallery,
    genericFlatButtonBackgroundColor: '#2979FF',
    genericFlatButtonColor: '#2979FF',
    ghost: '#C3C7CE',
    grey,
    heather: '#B7C3D0',
    highlight1Color: '#E00000',
    highlight2Color: '#FF7043',
    highlight3Color: '#FFB74D',
    highlight4Color: '#FFCC1B',
    highlight5Color: '#95C859',
    highlight6Color: '#1283C5',
    highlightBarBackgroundColor: colors.blue400,
    lightBlue: '#e5efff',
    lynch,
    loblolly: '#B7C0C8',
    menuItemHoverBackgroundColor: '#e7effd',
    minorButtonGrey: '#bdbdbd',
    malibu: '#76a6f7',
    mulledWine: '#4D415E',
    orange: colors.orange500,
    outrageousOrange: '#FA633C',
    playedContentBarBackgroundColor: colors.blue800,
    poloBlue: '#8DA8CC',
    popoverBorderColor: '#DFDFDF',
    provincialPink: '#FDF2ED',
    questionAnswerButtonColor: '#CCCCCC',
    royalBlue: '#346DE8',
    sidebarBackgroundColor: '#EEF3F5',
    silver,
    smoky: '#615276',
    temporaryHighlightBarBackgroundColor: colors.purple400,
    textareaBorderColor: '#E0E0E0',
    toolTipBackgroundColor: '#182133',
    voteDownColor: '#e35241',
    voteUpColor: '#00C853',
    waveformHoverColor: '#90adda',
    waveformUnplayedColor: '#b7c0c8',
    topRank: '#66A751',
    bottomRank: '#9F393B',
    multibarDark: '#54687D',
    multibarLight: '#A0A5B0',
    pastelBad: '#E96D6D',
    pastelGood: '#60A862',
    pastelNeutral: '#7C7C7C',
  },
  dialog: {
    bodyColor: textColor,
  },
  toggle: {
    thumbOnColor: lynch,
    trackOnColor: silver,
    trackOffColor: silver,
    thumbOffColor: grey,
  },
  raisedButton: {
    color: gallery,
    fontWeight: 'bold',
    fontSize: '13px',
    secondaryColor: flamingo,
  },
  radioButton: {
    borderColor: darkGrey,
    backgroundColor: darkGrey,
    checkedColor: darkGrey,
    requiredColor: darkGrey,
    disabledColor: darkGrey,
    labelColor: textColor,
    labelDisabledColor: darkGrey,
  },
};
